import React from 'react';
import { string } from 'prop-types';

// Components
import { Box, Typography } from '@mui/material';

// Styles
import { useTheme } from '@mui/material/styles';
import { headerStyles, parentStyles } from './Header.styles';

const Header = ({ customerNameShort }) => {
  const theme = useTheme();
  return (
    <Box sx={{ ...headerStyles(theme) }}>
      <Typography noWrap sx={{ ...parentStyles }} variant="h5">
        {customerNameShort || 'Loading...'}
      </Typography>
    </Box>
  );
};

Header.propTypes = {
  customerNameShort: string,
};

Header.defaultProps = {
  customerNameShort: undefined,
};

export default Header;
